import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as orderStatus from "../constants/orderStatus";
import * as config from "../constants/config";
import * as formatHelper from "../helpers/formatHelper";
import * as handlers from "../constants/handlers";

export const toDispenseTabInit = (tabId) => ({
    type: actionTypes.TO_DISPENSE_TAB_INIT,
    payload: {
        tabId: tabId
    }
});

export const getToDispenseOrders = (
    tabId,
    availableOnly,
    filter,
    sortingAsc,
    sortingCriterion,
    searchFields,
    minNominalAmount,
    maxNominalAmount,
    productNames
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
        params: {
            asc: sortingAsc,
            availableOnly: availableOnly,
            maxNominalAmount: maxNominalAmount,
            minNominalAmount: minNominalAmount,
            offset: 0,
            orderBy: sortingCriterion,
            products: productNames,
            rowCount: config.MAX_ORDERS_LIMIT,
            search: filter,
            searchFields: formatHelper.getOrderSearchItemsForServer(searchFields),
            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST
        }
    },
    method: handlers.TO_DISPENSE_GET_ORDERS,
    tabId: tabId
});

export const reloadToDispenseOrders = (
    tabId,
    availableOnly,
    filter,
    offset,
    products,
    fandecks,
    formulas,
    customers,
    dateFrom,
    dateTo,
    minNominalAmount,
    maxNominalAmount,
    sortingAsc,
    sortingCriterion,
    searchFields
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
        params: {
            asc: sortingAsc,
            availableOnly: availableOnly,
            colors: formulas,
            customers: customers,
            dateFrom: dateFrom,
            dateTo: dateTo,
            fandecks: fandecks,
            maxNominalAmount: maxNominalAmount,
            minNominalAmount: minNominalAmount,
            offset: offset,
            orderBy: sortingCriterion,
            products: products,
            rowCount: config.MAX_ORDERS_LIMIT,
            search: filter,
            searchFields: formatHelper.getOrderSearchItemsForServer(searchFields),
            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST
        }
    },
    method: handlers.TO_DISPENSE_GET_ORDERS_WITH_OFFSET,
    tabId: tabId
});

export const getToDispenseOrderDetail = (tabId, orderId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ORDER_DETAIL,
        params: {
            id: orderId
        }
    },
    method: handlers.TO_DISPENSE_GET_DETAIL,
    tabId: tabId
});

export const changeNumberOfPackages = (tabId, numberOfPackages) => ({
    type: actionTypes.TO_DISPENSE_CHANGE_NUMBER_OF_PACKAGES,
    payload: {
        tabId: tabId,
        packageCount: numberOfPackages
    }
});

export const changeSorting = (tabId, criterion, asc) => ({
    type: actionTypes.TO_DISPENSE_SAVE_SORTING,
    payload: {
        tabId: tabId,
        criterion: criterion,
        asc: asc
    }
});

export const changeFilter = (tabId, filter) => ({
    type: actionTypes.TO_DISPENSE_SAVE_FILTER,
    payload: {
        tabId: tabId,
        filter: filter
    }
});

export const changeOffset = (tabId, offset) => ({
    type: actionTypes.TO_DISPENSE_CHANGE_OFFSET,
    payload: {
        tabId: tabId,
        offset: offset
    }
});

export const resetNewOrders = () => ({
    type: actionTypes.TO_DISPENSE_RESET_NEW_ORDERS
});

export const deleteOrder = (order) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ORDER_STATUS,
        params: {
            orderIdentifier: order.identifier,
            status: orderStatus.ORDER_STATUS_CANCELED
        }
    },
    method: handlers.TO_DISPENSE_DELETE_ORDER,
    tabId: 0
});

export const assignOrder = (orderId, orderIdentifier = null, clientIdentifier = null) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ASSIGN_ORDER,
        params: {
            id: orderId,
            identifier: orderIdentifier,
            clientIdentifier: clientIdentifier
        }
    },
    method: handlers.ASSIGN_ORDER,
    tabId: 0
});

export const releaseOrder = (orderId, orderIdentifier = null) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_RELEASE_ORDER,
        params: {
            id: orderId,
            identifier: orderIdentifier
        }
    },
    method: handlers.RELEASE_ORDER,
    tabId: 0
});

export const changeFilterType = (filterType, tabId) => ({
    type: actionTypes.TO_DISPENSE_SAVE_FILTER_TYPE,
    payload: {
        filterType: filterType,
        tabId: tabId
    }
});

export const setColorantDispensingLogic = (colorantName, dispensingLogic) => ({
    type: actionTypes.TO_DISPENSE_SET_COLORANT_DISPENSING_LOGIC,
    payload: {
        colorantName: colorantName,
        dispensingLogic: dispensingLogic
    }
});

export const setOrderStatusDone = (tabId, order) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_ORDER_STATUS,
        params: {
            orderIdentifier: order.identifier,
            status: orderStatus.ORDER_STATUS_DONE
        }
    },
    method: handlers.TO_DISPENSE_SET_ORDER_STATUS_DONE,
    tabId: tabId
});

export const resetOrder = () => ({
    type: actionTypes.TO_DISPENSE_RESET_ORDER
});

export const openToDispenseOrderInNewTab = (identifier) => ({
    type: actionTypes.OPEN_TO_DISPENSE_ORDER_IN_NEW_TAB,
    payload: {
        identifier: identifier
    }
});

export const startDispensing = (tabId) => ({
    type: actionTypes.TO_DISPENSE_START_DISPENSING,
    payload: {
        tabId: tabId
    }
});

export const addColorStatsFromOrderAndDispense = (tabId, packageCount) => ({
    type: actionTypes.ADD_COLOR_STATS_FROM_ORDER_AND_DISPENSE,
    payload: {
        tabId: tabId,
        packageCount: packageCount
    }
});
